import { render, staticRenderFns } from "./prediction_upload.vue?vue&type=template&id=3683b73c&scoped=true&"
import script from "./prediction_upload.vue?vue&type=script&lang=js&"
export * from "./prediction_upload.vue?vue&type=script&lang=js&"
import style0 from "./prediction_upload.vue?vue&type=style&index=0&id=3683b73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683b73c",
  null
  
)

export default component.exports